module.exports = __webpack_public_path__ + "static/index/img/baikal-905.bb7116fb.jpg";